import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TEST_IDS } from '../testIds';
import { useAppSelector } from '../../../../../hooks/reduxHooks';

const useWorkerSubstanceFieldsConfig = ({ t, wokerFormData, handleBlurValidation, ingressDate }: any) => {
    const [workerSubstanceFieldsConfig, setWorkerSubstanceFieldsConfig] = useState<FieldConfig[]>([]);
    const carcinogenicParametricData = useAppSelector(
        (state) => state.carcinogenicReport.carcinogenicParametricData
    );

    useEffect(() => {
        const workerSubstanceFieldsConfig: FieldConfig[] = [
            {
                type: 'date',
                label: t('workerForm.inputs.expositionDateStart') as string,
                name: 'expositionDateStart',
                required: true,
                value: wokerFormData.expositionDateStart,
                disabled: false,
                helperText: t('workerForm.inputs.expositionDateStart') as string,
                onBlurValidation: () => {},
                inputType: 'number',
                minDate: ingressDate || undefined,
                maxDate: wokerFormData?.expositionDateEnd,
                options: carcinogenicParametricData?.tiposEstudio,
                getOptionLabel: (item) => `${item?.descripcion}`,
                gridSpace: { xs: 6 },
                testID: TEST_IDS.editSubstancesAndMedicalExams.substancesForms.substanceFormFields
                    .expositionDateStart,
                validations: [{ name: 'required' }]
            },
            {
                type: 'date',
                label: t('workerForm.inputs.expositionDateEnd') as string,
                name: 'expositionDateEnd',
                required: false,
                value: wokerFormData.expositionDateEnd,
                disabled: false,
                helperText: t('workerSubstances.inputs.expositionDateEnd') as string,
                onBlurValidation: () => {},
                gridSpace: { xs: 6 },
                minDate: wokerFormData?.expositionDateStart,
                testID: TEST_IDS.editSubstancesAndMedicalExams.substancesForms.substanceFormFields
                    .expositionDateEnd
                // validations: [{ name: 'required' }]
            },
            {
                type: 'autocomplete-default',
                label: t('workerForm.inputs.medicalExams') as string,
                name: 'medicalExams',
                required: true,
                value: wokerFormData.medicalExams,
                disabled: false,
                multiple: true,
                helperText: t('workerForm.inputs.medicalExams') as string,
                onBlurValidation: () => {},
                options: carcinogenicParametricData?.examenesMedico,
                getOptionLabel: (item) => `${item?.descripcion}`,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.editSubstancesAndMedicalExams.substancesForms.substanceFormFields
                    .medicalExams,
                validations: [{ name: 'required' }]
            }
        ];

        setWorkerSubstanceFieldsConfig(workerSubstanceFieldsConfig);
    }, [t, wokerFormData, carcinogenicParametricData, wokerFormData?.expositionDateStart, wokerFormData?.expositionDateEnd]);

    return { workerSubstanceFieldsConfig };
};

export default useWorkerSubstanceFieldsConfig;

